import React from 'react';
import PropTypes from 'prop-types';
import { Row, Column } from 'components/shared/Layout';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { bookingStatus } from 'types/booking';
import moment from 'moment';
import { brandCode } from 'constants/brandCodes';
import { getFullBrandNameFromBrandCode } from 'constants/fullBrandNames';
import { StyledMismatchDataContainer, StyledContentContainer, StyledContent, StyledStatus } from './MultiInventoryConflictWarning.styles';

const MultiInventoryConflictWarningContent = ({ mismatchData = [], intl }) => (
  <Row data-testid="pao-and-s3-status-mismatch-details">
    <Column>
      {mismatchData.map((data, index) => (
        <StyledMismatchDataContainer
          key={`${data?.originName}-${data?.destinationName}--${index}`}
          data-testid={`${data?.departureDate}--${index}`}
        >
          <StyledContentContainer marginBot>
            <StyledContent bold>{moment(data?.departureDate).format('dddd Do MMM YYYY')}</StyledContent>
            <FormattedMessage
              id="manageBooking.paoAndS3MismatchStations"
              values={{
                origin: data?.originName,
                destination: data?.destinationName
              }}
            />
          </StyledContentContainer>
          <div>
            {data?.mismatchBetweenPaoAndS3?.map((mismatch, indexMismatch) => (
              <div key={`${mismatch?.firstName}-${mismatch?.lastName}--${indexMismatch}`}>
                <StyledContentContainer>
                  <StyledContent>{mismatch?.firstName}</StyledContent>
                  <StyledContent>{mismatch?.lastName}:</StyledContent>
                  <StyledContent bold>Eurostar: </StyledContent>
                  <StyledContent data-testid={`date${index}--pax${indexMismatch}--S3segment`}>
                    <StyledStatus status={mismatch?.s3Status}>
                      {mismatch?.s3Status === bookingStatus.CANCELLED ? (
                        <FormattedMessage id="manageBooking.s3Cancelled" />
                      ) : (
                        <FormattedMessage id="manageBooking.paoAndS3Confirmed" />
                      )}
                    </StyledStatus>
                  </StyledContent>
                  <StyledContent bold>{getFullBrandNameFromBrandCode({ brandCode: data?.serviceType?.brandCode })}: </StyledContent>
                  <StyledContent data-testid={`date${index}--pax${indexMismatch}--PAOsegment`}>
                    <StyledStatus status={mismatch?.paoStatus}>
                      {mismatch?.paoStatus === bookingStatus.CANCELLED ? (
                        <FormattedMessage id="manageBooking.paoCancelled" />
                      ) : (
                        <FormattedMessage id="manageBooking.paoAndS3Confirmed" />
                      )}
                    </StyledStatus>
                  </StyledContent>
                </StyledContentContainer>
              </div>
            ))}
          </div>
          <br />
          {brandCode.INOUI === data?.serviceType?.brandCode ? (
            <span data-testid="sncf-mismatch-text">
              <FormattedMessage
                id="manageBooking.paoAndS3MismatchSNCFVoyagerMessage"
                values={{
                  link: (
                    <a href={intl.formatMessage({ id: 'manageBooking.paoAndS3MismatchSNCFVoyagerURL' })} target="_blank" rel="noreferrer">
                      <FormattedMessage id="manageBooking.paoAndS3MismatchSNCFVoyagerLinkText" />
                    </a>
                  )
                }}
              />
            </span>
          ) : (
            <span data-testid="pao-mismatch-text">
              <FormattedMessage id="manageBooking.paoAndS3MismatchMessage" />
            </span>
          )}
        </StyledMismatchDataContainer>
      ))}
    </Column>
  </Row>
);

MultiInventoryConflictWarningContent.propTypes = {
  mismatchData: PropTypes.arrayOf(
    PropTypes.shape({
      departureDate: PropTypes.string,
      originName: PropTypes.string,
      destinationName: PropTypes.string,
      mismatchBetweenPaoAndS3: PropTypes.arrayOf(
        PropTypes.shape({
          firstName: PropTypes.string,
          lastName: PropTypes.string,
          s3Status: PropTypes.string,
          paoStatus: PropTypes.string
        })
      )
    })
  ),
  intl: intlShape.isRequired
};

export default injectIntl(MultiInventoryConflictWarningContent);
